import React from 'react';
import { Typography, Button } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import whiteChevron from '../../../asset/images/icons/es_chevron_down_sm_white.svg';
import blackChevron from '../../../asset/images/icons/es_chevron_down_sm_black.svg';
import CustomLazyLoadImage from '../../Image/CustomLazyLoadImage';

interface IFilterButton {
    onPress: () => void;
    mainStyle?: any;
    textStyle?: any;
    value: string;
    isSolidButton?: boolean;
    open?: boolean;
}
const FilterButton = React.forwardRef(
    ({ onPress, mainStyle, textStyle, value, isSolidButton, open }: IFilterButton, ref: any) => {
        const { themeStyle, darkModeEnabled } = useThemeContext();
        return (
            <Button
                style={mainStyle}
                ref={ref}
                sx={{
                    border: 'none',
                    '&:hover': { border: `1px solid ${theme[themeStyle].primary_orange}` },
                    overflow: 'hidden',
                    maxWidth: 150, // Set maximum width for the button
                    textOverflow: 'ellipsis', // Display ellipses for overflow
                    whiteSpace: 'nowrap',
                }}
                onClick={onPress}>
                <Typography
                    style={textStyle}
                    sx={{
                        maxWidth: 'calc(100% - 30px)', // Adjust for the arrow width
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                    {value}
                </Typography>
                <CustomLazyLoadImage
                    src={
                        isSolidButton
                            ? darkModeEnabled
                                ? blackChevron
                                : whiteChevron
                            : darkModeEnabled
                            ? whiteChevron
                            : blackChevron
                    }
                    alt="dropdown filter arrow"
                    style={{
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'all 400ms',
                    }}
                />
            </Button>
        );
    },
);

export { FilterButton };
